// AI-CONTEXT: See docs/patterns.md#hook-permission-gate
// AI-CONTEXT: See docs/features/role-based-permissions.md

import { useContext } from "react"
import { Permissions } from "../StateManagment/Permissions"

const usePermissions = () => useContext(Permissions)

export default usePermissions
